import React from 'react';
import './ConfirmationModal.scss';

interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  variant?: 'danger' | 'warning' | 'info';
  icon?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  isLoading = false,
  variant = 'warning',
  icon,
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    if (icon) return icon;
    switch (variant) {
      case 'danger':
        return 'bx bx-error-circle';
      case 'warning':
        return 'bx bx-error-circle';
      case 'info':
        return 'bx bx-info-circle';
      default:
        return 'bx bx-info-circle';
    }
  };

  const getIconColor = () => {
    switch (variant) {
      case 'danger':
        return '#dc3545';
      case 'warning':
        return '#ffc107';
      case 'info':
        return '#0dcaf0';
      default:
        return '#6c757d';
    }
  };

  const getConfirmButtonClass = () => {
    switch (variant) {
      case 'danger':
        return 'btn-confirm-danger';
      case 'warning':
        return 'btn-confirm-warning';
      case 'info':
        return 'btn-confirm-info';
      default:
        return 'btn-confirm-default';
    }
  };

  return (
    <div className="confirmation-modal-overlay" onClick={onCancel}>
      <div className="confirmation-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="confirmation-modal-header">
          <h3>{title}</h3>
          <button
            className="btn-close-modal"
            onClick={onCancel}
            disabled={isLoading}
          >
            <i className="bx bx-x"></i>
          </button>
        </div>
        <div className="confirmation-modal-body">
          <div className="confirmation-modal-icon" style={{ color: getIconColor() }}>
            <i className={getIcon()}></i>
          </div>
          <p className="confirmation-modal-message">{message}</p>
        </div>
        <div className="confirmation-modal-footer">
          <button
            className="btn-cancel-confirm"
            onClick={onCancel}
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button
            className={getConfirmButtonClass()}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className="bx bx-loader-alt bx-spin"></i>
                Processing...
              </>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;

